import { useEffect } from "react";

import { Column, KeyboardShortcut, Row, Text } from "@/components";
import { Button } from "@/components/ui/button";

import { SCREENING_PROMPT_ACTION_CLASSNAME } from "@/lib/constants";

import { ScreeningStepHeader } from "./ScreeningStepHeader";

// Step 1 of reject: did the screen actually happen? Drives whether it counts on
// the leaderboard. Y/N keybinds are safe — the prompt has no global keybinds.
export const RejectScreenedStep = ({
  candidateName,
  isUpdatePending,
  onBack,
  onDismiss,
  onNo,
  onYes,
}: {
  candidateName: string;
  isUpdatePending: boolean;
  onBack: () => void;
  onDismiss: () => void;
  onNo: () => void;
  onYes: () => void;
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "y" || e.key === "Y") {
        e.preventDefault();
        onYes();
      }
      if (e.key === "n" || e.key === "N") {
        e.preventDefault();
        onNo();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Column className="gap-0">
      <ScreeningStepHeader
        title="Reject candidate"
        onBack={onBack}
        onDismiss={onDismiss}
      />
      <Column className="gap-2 px-3.5 pb-2.5 pt-2">
        <Column className="gap-0.5">
          <Text className="text-sm font-semibold text-slate-900" truncate>
            Was {candidateName} screened?
          </Text>
          <Text className="text-[10px] font-normal text-slate-400">
            “Yes” counts this as a screen on the leaderboard.
          </Text>
        </Column>
        <Row className="gap-1.5">
          <Button
            variant="outlineSecondary"
            size="sm"
            disabled={isUpdatePending}
            className={SCREENING_PROMPT_ACTION_CLASSNAME}
            onClick={onNo}
          >
            No
            <KeyboardShortcut text="N" />
          </Button>
          <Button
            size="sm"
            disabled={isUpdatePending}
            className={SCREENING_PROMPT_ACTION_CLASSNAME}
            onClick={onYes}
          >
            Yes
            <KeyboardShortcut text="Y" variant="primary" />
          </Button>
        </Row>
      </Column>
    </Column>
  );
};
